import { ObjectSerializer2kjkucmygguwd as ObjectSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/ObjectSerializer.mjs';
import {
  ModificationChainSerializer3eo283b0evyr4 as ModificationChainSerializer,
  ModificationIfNotNullSerializer1sbx3dkpdrrqw as ModificationIfNotNullSerializer,
  ModificationAssignSerializerysm6r8t6aqbz as ModificationAssignSerializer,
  ModificationCoerceAtMostSerializer2lyh2fkcuv7je as ModificationCoerceAtMostSerializer,
  ModificationCoerceAtLeastSerializer1tywcjfyjots as ModificationCoerceAtLeastSerializer,
  ModificationIncrementSerializer2f5w496dzjgtq as ModificationIncrementSerializer,
  ModificationMultiplySerializervdky5wcvbwoj as ModificationMultiplySerializer,
  ModificationAppendStringSerializer_getInstance33npjshy4ul8q as ModificationAppendStringSerializer_getInstance,
  ModificationAppendRawStringSerializeruylfpg2mbkb7 as ModificationAppendRawStringSerializer,
  ModificationListAppendSerializer24hdf74drm9fb as ModificationListAppendSerializer,
  ModificationListRemoveSerializer1cyj9g0hbaq08 as ModificationListRemoveSerializer,
  ModificationListRemoveInstancesSerializerupov89hctwev as ModificationListRemoveInstancesSerializer,
  ModificationListDropFirstSerializersm4xxwngsfl4 as ModificationListDropFirstSerializer,
  ModificationListDropLastSerializerbns6ffxbuvwe as ModificationListDropLastSerializer,
  ModificationSerializer3ubms8rrlijys as ModificationSerializer,
  ModificationSetAppendSerializer5m15u4jowgug as ModificationSetAppendSerializer,
  ModificationSetRemoveSerializerizso0ytsxizv as ModificationSetRemoveSerializer,
  ModificationSetRemoveInstancesSerializer1avgdfaqi6nv2 as ModificationSetRemoveInstancesSerializer,
  ModificationSetDropFirstSerializer2g6vdsy7wrf51 as ModificationSetDropFirstSerializer,
  ModificationSetDropLastSerializer3eykhkeb9sfx1 as ModificationSetDropLastSerializer,
  ModificationCombineSerializer2afeyhg59cg1i as ModificationCombineSerializer,
  ModificationModifyByKeySerializerxlhu7pojz7sb as ModificationModifyByKeySerializer,
  ModificationRemoveKeysSerializer2uyawkczz06wj as ModificationRemoveKeysSerializer,
} from './ModificationSerialization.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { ConditionSerializer21tf3x2n3amih as ConditionSerializer } from './ConditionSerialization.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMap140uvy3s5zad8 as KtMap,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isComparableviyv6ctzm76u as isComparable,
  isNumberiramasdbon0i as isNumber,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  plus310ted5e4i90h as plus,
  minus2znw4oicpx34e as minus,
  drop3na99dw9feawf as drop,
  dropLast1vpiyky649o34 as dropLast,
  toSet2orjxp16sotqu as toSet,
  toList3jhuyej2anx2q as toList,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  coerceAtMost31oazapy1u82u as coerceAtMost,
  coerceAtLeast3jlgfquiyquc9 as coerceAtLeast,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import {
  plus1odefccxt2tsw as plus_0,
  timesygsvtzjjihwo as times,
} from './numplus.mjs';
import { IsRawStringxv018dzbtx4q as IsRawString } from '../StringAlts.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import {
  plus1ogy4liedzq5j as plus_1,
  minus165a8u1e0x1lu as minus_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { plus2m1vv33moko5t as plus_2 } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.i3l_1.f2();
}
function Modification$Nothing$_anonymous__h2kh1q() {
  var tmp = Nothing_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ObjectSerializer().e1c('com.lightningkite.lightningdb.Modification.Nothing', tmp, tmp$ret$2);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationChainSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function Modification$Chain$toString$lambda(it) {
  return toString(it);
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationIfNotNullSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationAssignSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationCoerceAtMostSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationCoerceAtLeastSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationIncrementSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationMultiplySerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      k2a() {
        return ModificationAppendStringSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationAppendRawStringSerializer())();
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_7;
function Companion_getInstance_7() {
  return Companion_instance_7;
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationListAppendSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationListRemoveSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationListRemoveInstancesSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
var CompanionClass_11;
function Companion_11() {
  if (CompanionClass_11 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationListDropFirstSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_11 = $;
  }
  return CompanionClass_11;
}
var Companion_instance_11;
function Companion_getInstance_11() {
  return Companion_instance_11;
}
var CompanionClass_12;
function Companion_12() {
  if (CompanionClass_12 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationListDropLastSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_12 = $;
  }
  return CompanionClass_12;
}
var Companion_instance_12;
function Companion_getInstance_12() {
  return Companion_instance_12;
}
var CompanionClass_13;
function Companion_13() {
  if (CompanionClass_13 === VOID) {
    class $ {
      constructor() {
        Companion_instance_13 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('ListPerElement', null, 2);
        tmp0_serialDesc.a1b('condition', false);
        tmp0_serialDesc.a1b('modification', false);
        this.j3l_1 = tmp0_serialDesc;
      }
      b2j(typeSerial0) {
        return $serializer().p41(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_13 = $;
  }
  return CompanionClass_13;
}
var Companion_instance_13;
function Companion_getInstance_13() {
  if (Companion_instance_13 === VOID)
    new (Companion_13())();
  return Companion_instance_13;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      static q41() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('ListPerElement', $this, 2);
        tmp0_serialDesc.a1b('condition', false);
        tmp0_serialDesc.a1b('modification', false);
        $this.n41_1 = tmp0_serialDesc;
        return $this;
      }
      r41(encoder, value) {
        var tmp0_desc = this.n41_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, new (ConditionSerializer())(this.o41_1), value.s41_1);
        tmp1_output.c15(tmp0_desc, 1, new (ModificationSerializer())(this.o41_1), value.t41_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.r41(encoder, value instanceof ListPerElement() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.n41_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.o41_1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, new (ModificationSerializer())(this.o41_1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.o41_1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, new (ModificationSerializer())(this.o41_1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return ListPerElement().u41(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.n41_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ConditionSerializer())(this.o41_1), new (ModificationSerializer())(this.o41_1)];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.o41_1];
      }
      static p41(typeSerial0) {
        var $this = this.q41();
        $this.o41_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var CompanionClass_14;
function Companion_14() {
  if (CompanionClass_14 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationSetAppendSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_14 = $;
  }
  return CompanionClass_14;
}
var Companion_instance_14;
function Companion_getInstance_14() {
  return Companion_instance_14;
}
var CompanionClass_15;
function Companion_15() {
  if (CompanionClass_15 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationSetRemoveSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_15 = $;
  }
  return CompanionClass_15;
}
var Companion_instance_15;
function Companion_getInstance_15() {
  return Companion_instance_15;
}
var CompanionClass_16;
function Companion_16() {
  if (CompanionClass_16 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationSetRemoveInstancesSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_16 = $;
  }
  return CompanionClass_16;
}
var Companion_instance_16;
function Companion_getInstance_16() {
  return Companion_instance_16;
}
var CompanionClass_17;
function Companion_17() {
  if (CompanionClass_17 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationSetDropFirstSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_17 = $;
  }
  return CompanionClass_17;
}
var Companion_instance_17;
function Companion_getInstance_17() {
  return Companion_instance_17;
}
var CompanionClass_18;
function Companion_18() {
  if (CompanionClass_18 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationSetDropLastSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_18 = $;
  }
  return CompanionClass_18;
}
var Companion_instance_18;
function Companion_getInstance_18() {
  return Companion_instance_18;
}
var CompanionClass_19;
function Companion_19() {
  if (CompanionClass_19 === VOID) {
    class $ {
      constructor() {
        Companion_instance_19 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('SetPerElement', null, 2);
        tmp0_serialDesc.a1b('condition', false);
        tmp0_serialDesc.a1b('modification', false);
        this.k3l_1 = tmp0_serialDesc;
      }
      b2j(typeSerial0) {
        return $serializer_0().x41(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_19 = $;
  }
  return CompanionClass_19;
}
var Companion_instance_19;
function Companion_getInstance_19() {
  if (Companion_instance_19 === VOID)
    new (Companion_19())();
  return Companion_instance_19;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      static y41() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('SetPerElement', $this, 2);
        tmp0_serialDesc.a1b('condition', false);
        tmp0_serialDesc.a1b('modification', false);
        $this.v41_1 = tmp0_serialDesc;
        return $this;
      }
      z41(encoder, value) {
        var tmp0_desc = this.v41_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, new (ConditionSerializer())(this.w41_1), value.a42_1);
        tmp1_output.c15(tmp0_desc, 1, new (ModificationSerializer())(this.w41_1), value.b42_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.z41(encoder, value instanceof SetPerElement() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.v41_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.w41_1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, new (ModificationSerializer())(this.w41_1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.w41_1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, new (ModificationSerializer())(this.w41_1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return SetPerElement().c42(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.v41_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ConditionSerializer())(this.w41_1), new (ModificationSerializer())(this.w41_1)];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.w41_1];
      }
      static x41(typeSerial0) {
        var $this = this.y41();
        $this.w41_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var CompanionClass_20;
function Companion_20() {
  if (CompanionClass_20 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationCombineSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_20 = $;
  }
  return CompanionClass_20;
}
var Companion_instance_20;
function Companion_getInstance_20() {
  return Companion_instance_20;
}
var CompanionClass_21;
function Companion_21() {
  if (CompanionClass_21 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationModifyByKeySerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_21 = $;
  }
  return CompanionClass_21;
}
var Companion_instance_21;
function Companion_getInstance_21() {
  return Companion_instance_21;
}
var CompanionClass_22;
function Companion_22() {
  if (CompanionClass_22 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationRemoveKeysSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_22 = $;
  }
  return CompanionClass_22;
}
var Companion_instance_22;
function Companion_getInstance_22() {
  return Companion_instance_22;
}
var NothingClass;
function Nothing() {
  if (NothingClass === VOID) {
    class $ extends Modification() {
      static d42() {
        Nothing_instance = null;
        var $this = this.e42();
        Nothing_instance = $this;
        var tmp = $this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.i3l_1 = lazy(tmp_0, Modification$Nothing$_anonymous__h2kh1q);
        return $this;
      }
      f42() {
        return true;
      }
      l3h(on) {
        return on;
      }
      r3q(on) {
        return this.l3h((on == null ? true : !(on == null)) ? on : THROW_CCE());
      }
      toString() {
        return '';
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
      hashCode() {
        return -494226397;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Nothing()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Nothing', VOID, VOID, [Modification(), SerializerFactory()], VOID, VOID, {0: Nothing_getInstance});
    NothingClass = $;
  }
  return NothingClass;
}
var Nothing_instance;
function Nothing_getInstance() {
  if (Nothing_instance === VOID)
    Nothing().d42();
  return Nothing_instance;
}
var ChainClass;
function Chain() {
  if (ChainClass === VOID) {
    class $ extends Modification() {
      static h42(modifications) {
        var $this = this.e42();
        $this.g42_1 = modifications;
        return $this;
      }
      f42() {
        var tmp0 = this.g42_1;
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.i1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (!element.f42()) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      r3q(on) {
        // Inline function 'kotlin.collections.fold' call
        var accumulator = on;
        var _iterator__ex2g4s = this.g42_1.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var item = accumulator;
          accumulator = element.r3q(item);
        }
        return accumulator;
      }
      toString() {
        return joinToString(this.g42_1, '; ', VOID, VOID, VOID, VOID, Modification$Chain$toString$lambda);
      }
      hashCode() {
        return hashCode(this.g42_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Chain()))
          return false;
        if (!equals(this.g42_1, other.g42_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Chain', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    ChainClass = $;
  }
  return ChainClass;
}
var IfNotNullClass;
function IfNotNull() {
  if (IfNotNullClass === VOID) {
    class $ extends Modification() {
      static j42(modification) {
        var $this = this.e42();
        $this.i42_1 = modification;
        return $this;
      }
      j3t(on) {
        var tmp;
        if (on == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = this.i42_1.r3q(on);
        }
        return tmp;
      }
      r3q(on) {
        return this.j3t((on == null ? true : !(on == null)) ? on : THROW_CCE());
      }
      toString() {
        return '?' + toString(this.i42_1);
      }
      hashCode() {
        return hashCode(this.i42_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IfNotNull()))
          return false;
        if (!equals(this.i42_1, other.i42_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'IfNotNull', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    IfNotNullClass = $;
  }
  return IfNotNullClass;
}
var AssignClass;
function Assign() {
  if (AssignClass === VOID) {
    class $ extends Modification() {
      static l42(value) {
        var $this = this.e42();
        $this.k42_1 = value;
        return $this;
      }
      r3q(on) {
        return this.k42_1;
      }
      toString() {
        return ' = ' + toString_0(this.k42_1);
      }
      hashCode() {
        return this.k42_1 == null ? 0 : hashCode(this.k42_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Assign()))
          return false;
        if (!equals(this.k42_1, other.k42_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Assign', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_1});
    AssignClass = $;
  }
  return AssignClass;
}
var CoerceAtMostClass;
function CoerceAtMost() {
  if (CoerceAtMostClass === VOID) {
    class $ extends Modification() {
      static n42(value) {
        var $this = this.e42();
        $this.m42_1 = value;
        return $this;
      }
      l3r(on) {
        return coerceAtMost(on, this.m42_1);
      }
      r3q(on) {
        return this.l3r((!(on == null) ? isComparable(on) : false) ? on : THROW_CCE());
      }
      toString() {
        return ' = .coerceAtMost(' + toString(this.m42_1) + ')';
      }
      hashCode() {
        return hashCode(this.m42_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CoerceAtMost()))
          return false;
        if (!equals(this.m42_1, other.m42_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CoerceAtMost', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_2});
    CoerceAtMostClass = $;
  }
  return CoerceAtMostClass;
}
var CoerceAtLeastClass;
function CoerceAtLeast() {
  if (CoerceAtLeastClass === VOID) {
    class $ extends Modification() {
      static p42(value) {
        var $this = this.e42();
        $this.o42_1 = value;
        return $this;
      }
      l3r(on) {
        return coerceAtLeast(on, this.o42_1);
      }
      r3q(on) {
        return this.l3r((!(on == null) ? isComparable(on) : false) ? on : THROW_CCE());
      }
      toString() {
        return ' = .coerceAtLeast(' + toString(this.o42_1) + ')';
      }
      hashCode() {
        return hashCode(this.o42_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CoerceAtLeast()))
          return false;
        if (!equals(this.o42_1, other.o42_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CoerceAtLeast', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_3});
    CoerceAtLeastClass = $;
  }
  return CoerceAtLeastClass;
}
var IncrementClass;
function Increment() {
  if (IncrementClass === VOID) {
    class $ extends Modification() {
      static r42(by) {
        var $this = this.e42();
        $this.q42_1 = by;
        return $this;
      }
      s42(on) {
        return plus_0(on, this.q42_1);
      }
      r3q(on) {
        return this.s42(isNumber(on) ? on : THROW_CCE());
      }
      toString() {
        return ' += ' + toString(this.q42_1);
      }
      hashCode() {
        return hashCode(this.q42_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Increment()))
          return false;
        if (!equals(this.q42_1, other.q42_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Increment', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_4});
    IncrementClass = $;
  }
  return IncrementClass;
}
var MultiplyClass;
function Multiply() {
  if (MultiplyClass === VOID) {
    class $ extends Modification() {
      static u42(by) {
        var $this = this.e42();
        $this.t42_1 = by;
        return $this;
      }
      s42(on) {
        return times(on, this.t42_1);
      }
      r3q(on) {
        return this.s42(isNumber(on) ? on : THROW_CCE());
      }
      toString() {
        return ' *= ' + toString(this.t42_1);
      }
      hashCode() {
        return hashCode(this.t42_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Multiply()))
          return false;
        if (!equals(this.t42_1, other.t42_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Multiply', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_5});
    MultiplyClass = $;
  }
  return MultiplyClass;
}
var AppendStringClass;
function AppendString() {
  if (AppendStringClass === VOID) {
    class $ extends Modification() {
      static w42(value) {
        var $this = this.e42();
        $this.v42_1 = value;
        return $this;
      }
      t3r(on) {
        return on + this.v42_1;
      }
      r3q(on) {
        return this.t3r((!(on == null) ? typeof on === 'string' : false) ? on : THROW_CCE());
      }
      toString() {
        return ' += ' + this.v42_1;
      }
      hashCode() {
        return getStringHashCode(this.v42_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AppendString()))
          return false;
        if (!(this.v42_1 === other.v42_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'AppendString', VOID, VOID, VOID, VOID, VOID, {0: ModificationAppendStringSerializer_getInstance});
    AppendStringClass = $;
  }
  return AppendStringClass;
}
var AppendRawStringClass;
function AppendRawString() {
  if (AppendRawStringClass === VOID) {
    class $ extends Modification() {
      static y42(value) {
        var $this = this.e42();
        $this.x42_1 = value;
        return $this;
      }
      v3r(on) {
        var tmp = on.i3n((it) => it + this.x42_1);
        return isInterface(tmp, IsRawString()) ? tmp : THROW_CCE();
      }
      r3q(on) {
        return this.v3r((!(on == null) ? isInterface(on, IsRawString()) : false) ? on : THROW_CCE());
      }
      toString() {
        return ' += ' + this.x42_1;
      }
      hashCode() {
        return getStringHashCode(this.x42_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AppendRawString()))
          return false;
        if (!(this.x42_1 === other.x42_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'AppendRawString', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_7});
    AppendRawStringClass = $;
  }
  return AppendRawStringClass;
}
var ListAppendClass;
function ListAppend() {
  if (ListAppendClass === VOID) {
    class $ extends Modification() {
      static a43(items) {
        var $this = this.e42();
        $this.z42_1 = items;
        return $this;
      }
      b43(on) {
        return plus(on, this.z42_1);
      }
      r3q(on) {
        return this.b43((!(on == null) ? isInterface(on, KtList()) : false) ? on : THROW_CCE());
      }
      toString() {
        return ' += ' + toString(this.z42_1);
      }
      hashCode() {
        return hashCode(this.z42_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListAppend()))
          return false;
        if (!equals(this.z42_1, other.z42_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ListAppend', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_8});
    ListAppendClass = $;
  }
  return ListAppendClass;
}
var ListRemoveClass;
function ListRemove() {
  if (ListRemoveClass === VOID) {
    class $ extends Modification() {
      static d43(condition) {
        var $this = this.e42();
        $this.c43_1 = condition;
        return $this;
      }
      b43(on) {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s = on.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (!this.c43_1.r3q(element)) {
            destination.v(element);
          }
        }
        return destination;
      }
      r3q(on) {
        return this.b43((!(on == null) ? isInterface(on, KtList()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.removeAll { it.' + toString(this.c43_1) + ' }';
      }
      hashCode() {
        return this.c43_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListRemove()))
          return false;
        if (!this.c43_1.equals(other.c43_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ListRemove', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_9});
    ListRemoveClass = $;
  }
  return ListRemoveClass;
}
var ListRemoveInstancesClass;
function ListRemoveInstances() {
  if (ListRemoveInstancesClass === VOID) {
    class $ extends Modification() {
      static f43(items) {
        var $this = this.e42();
        $this.e43_1 = items;
        return $this;
      }
      b43(on) {
        return minus(on, this.e43_1);
      }
      r3q(on) {
        return this.b43((!(on == null) ? isInterface(on, KtList()) : false) ? on : THROW_CCE());
      }
      toString() {
        return ' -= ' + toString(this.e43_1);
      }
      hashCode() {
        return hashCode(this.e43_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListRemoveInstances()))
          return false;
        if (!equals(this.e43_1, other.e43_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ListRemoveInstances', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_10});
    ListRemoveInstancesClass = $;
  }
  return ListRemoveInstancesClass;
}
var ListDropFirstClass;
function ListDropFirst() {
  if (ListDropFirstClass === VOID) {
    class $ extends Modification() {
      static g43() {
        return this.e42();
      }
      b43(on) {
        return drop(on, 1);
      }
      r3q(on) {
        return this.b43((!(on == null) ? isInterface(on, KtList()) : false) ? on : THROW_CCE());
      }
      hashCode() {
        return 1;
      }
      equals(other) {
        return !((other instanceof ListDropFirst() ? other : null) == null);
      }
      toString() {
        return '.removeFirst()';
      }
    }
    initMetadataForClass($, 'ListDropFirst', $.g43, VOID, VOID, VOID, VOID, {0: Companion_getInstance_11});
    ListDropFirstClass = $;
  }
  return ListDropFirstClass;
}
var ListDropLastClass;
function ListDropLast() {
  if (ListDropLastClass === VOID) {
    class $ extends Modification() {
      static h43() {
        return this.e42();
      }
      b43(on) {
        return dropLast(on, 1);
      }
      r3q(on) {
        return this.b43((!(on == null) ? isInterface(on, KtList()) : false) ? on : THROW_CCE());
      }
      hashCode() {
        return 1;
      }
      equals(other) {
        return !((other instanceof ListDropLast() ? other : null) == null);
      }
      toString() {
        return '.removeLast()';
      }
    }
    initMetadataForClass($, 'ListDropLast', $.h43, VOID, VOID, VOID, VOID, {0: Companion_getInstance_12});
    ListDropLastClass = $;
  }
  return ListDropLastClass;
}
var ListPerElementClass;
function ListPerElement() {
  if (ListPerElementClass === VOID) {
    class $ extends Modification() {
      b43(on) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(on, 10));
        var _iterator__ex2g4s = on.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var tmp$ret$0 = this.s41_1.r3q(item) ? this.t41_1.r3q(item) : item;
          destination.v(tmp$ret$0);
        }
        return destination;
      }
      r3q(on) {
        return this.b43((!(on == null) ? isInterface(on, KtList()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.onEach { if (it.' + toString(this.s41_1) + ') it.' + toString(this.t41_1) + ' }';
      }
      hashCode() {
        var result = this.s41_1.hashCode();
        result = imul(result, 31) + hashCode(this.t41_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListPerElement()))
          return false;
        if (!this.s41_1.equals(other.s41_1))
          return false;
        if (!equals(this.t41_1, other.t41_1))
          return false;
        return true;
      }
      static u41(seen0, condition, modification, serializationConstructorMarker) {
        Companion_getInstance_13();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, Companion_getInstance_13().j3l_1);
        }
        var $this = this.e42();
        $this.s41_1 = condition;
        $this.t41_1 = modification;
        return $this;
      }
    }
    initMetadataForClass($, 'ListPerElement', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_13});
    ListPerElementClass = $;
  }
  return ListPerElementClass;
}
var SetAppendClass;
function SetAppend() {
  if (SetAppendClass === VOID) {
    class $ extends Modification() {
      static j43(items) {
        var $this = this.e42();
        $this.i43_1 = items;
        return $this;
      }
      k43(on) {
        return plus_1(on, this.i43_1);
      }
      r3q(on) {
        return this.k43((!(on == null) ? isInterface(on, KtSet()) : false) ? on : THROW_CCE());
      }
      toString() {
        return ' += ' + toString(this.i43_1);
      }
      hashCode() {
        return hashCode(this.i43_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SetAppend()))
          return false;
        if (!equals(this.i43_1, other.i43_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SetAppend', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_14});
    SetAppendClass = $;
  }
  return SetAppendClass;
}
var SetRemoveClass;
function SetRemove() {
  if (SetRemoveClass === VOID) {
    class $ extends Modification() {
      static m43(condition) {
        var $this = this.e42();
        $this.l43_1 = condition;
        return $this;
      }
      k43(on) {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s = on.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (!this.l43_1.r3q(element)) {
            destination.v(element);
          }
        }
        return toSet(destination);
      }
      r3q(on) {
        return this.k43((!(on == null) ? isInterface(on, KtSet()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.removeAll { it.' + toString(this.l43_1) + ' }';
      }
      hashCode() {
        return this.l43_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SetRemove()))
          return false;
        if (!this.l43_1.equals(other.l43_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SetRemove', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_15});
    SetRemoveClass = $;
  }
  return SetRemoveClass;
}
var SetRemoveInstancesClass;
function SetRemoveInstances() {
  if (SetRemoveInstancesClass === VOID) {
    class $ extends Modification() {
      static o43(items) {
        var $this = this.e42();
        $this.n43_1 = items;
        return $this;
      }
      k43(on) {
        return minus_0(on, this.n43_1);
      }
      r3q(on) {
        return this.k43((!(on == null) ? isInterface(on, KtSet()) : false) ? on : THROW_CCE());
      }
      toString() {
        return ' -= ' + toString(this.n43_1);
      }
      hashCode() {
        return hashCode(this.n43_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SetRemoveInstances()))
          return false;
        if (!equals(this.n43_1, other.n43_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SetRemoveInstances', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_16});
    SetRemoveInstancesClass = $;
  }
  return SetRemoveInstancesClass;
}
var SetDropFirstClass;
function SetDropFirst() {
  if (SetDropFirstClass === VOID) {
    class $ extends Modification() {
      static p43() {
        return this.e42();
      }
      k43(on) {
        return toSet(drop(on, 1));
      }
      r3q(on) {
        return this.k43((!(on == null) ? isInterface(on, KtSet()) : false) ? on : THROW_CCE());
      }
      hashCode() {
        return 1;
      }
      equals(other) {
        return !((other instanceof SetDropFirst() ? other : null) == null);
      }
      toString() {
        return '.removeFirst()';
      }
    }
    initMetadataForClass($, 'SetDropFirst', $.p43, VOID, VOID, VOID, VOID, {0: Companion_getInstance_17});
    SetDropFirstClass = $;
  }
  return SetDropFirstClass;
}
var SetDropLastClass;
function SetDropLast() {
  if (SetDropLastClass === VOID) {
    class $ extends Modification() {
      static q43() {
        return this.e42();
      }
      k43(on) {
        return toSet(dropLast(toList(on), 1));
      }
      r3q(on) {
        return this.k43((!(on == null) ? isInterface(on, KtSet()) : false) ? on : THROW_CCE());
      }
      hashCode() {
        return 1;
      }
      equals(other) {
        return !((other instanceof SetDropLast() ? other : null) == null);
      }
      toString() {
        return '.removeLast()';
      }
    }
    initMetadataForClass($, 'SetDropLast', $.q43, VOID, VOID, VOID, VOID, {0: Companion_getInstance_18});
    SetDropLastClass = $;
  }
  return SetDropLastClass;
}
var SetPerElementClass;
function SetPerElement() {
  if (SetPerElementClass === VOID) {
    class $ extends Modification() {
      k43(on) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(on, 10));
        var _iterator__ex2g4s = on.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var tmp$ret$0 = this.a42_1.r3q(item) ? this.b42_1.r3q(item) : item;
          destination.v(tmp$ret$0);
        }
        return toSet(destination);
      }
      r3q(on) {
        return this.k43((!(on == null) ? isInterface(on, KtSet()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.onEach { if (' + toString(this.a42_1) + ') ' + toString(this.b42_1) + ' }';
      }
      hashCode() {
        var result = this.a42_1.hashCode();
        result = imul(result, 31) + hashCode(this.b42_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SetPerElement()))
          return false;
        if (!this.a42_1.equals(other.a42_1))
          return false;
        if (!equals(this.b42_1, other.b42_1))
          return false;
        return true;
      }
      static c42(seen0, condition, modification, serializationConstructorMarker) {
        Companion_getInstance_19();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, Companion_getInstance_19().k3l_1);
        }
        var $this = this.e42();
        $this.a42_1 = condition;
        $this.b42_1 = modification;
        return $this;
      }
    }
    initMetadataForClass($, 'SetPerElement', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_19});
    SetPerElementClass = $;
  }
  return SetPerElementClass;
}
var CombineClass;
function Combine() {
  if (CombineClass === VOID) {
    class $ extends Modification() {
      static s43(map) {
        var $this = this.e42();
        $this.r43_1 = map;
        return $this;
      }
      t43(on) {
        return plus_2(on, this.r43_1);
      }
      r3q(on) {
        return this.t43((!(on == null) ? isInterface(on, KtMap()) : false) ? on : THROW_CCE());
      }
      toString() {
        return ' += ' + toString(this.r43_1);
      }
      hashCode() {
        return hashCode(this.r43_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Combine()))
          return false;
        if (!equals(this.r43_1, other.r43_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Combine', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_20});
    CombineClass = $;
  }
  return CombineClass;
}
var ModifyByKeyClass;
function ModifyByKey() {
  if (ModifyByKeyClass === VOID) {
    class $ extends Modification() {
      static v43(map) {
        var $this = this.e42();
        $this.u43_1 = map;
        return $this;
      }
      t43(on) {
        // Inline function 'kotlin.collections.mapValues' call
        var this_0 = this.u43_1;
        // Inline function 'kotlin.collections.mapValuesTo' call
        var destination = LinkedHashMap().fc(mapCapacity(this_0.p1()));
        // Inline function 'kotlin.collections.associateByTo' call
        var _iterator__ex2g4s = this_0.d2().m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var tmp = element.e2();
          var tmp0_safe_receiver = on.p3(element.e2());
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = element.f2().r3q(tmp0_safe_receiver);
          }
          var tmp1_elvis_lhs = tmp_0;
          var tmp_1;
          if (tmp1_elvis_lhs == null) {
            throw Exception().td();
          } else {
            tmp_1 = tmp1_elvis_lhs;
          }
          var tmp$ret$3 = tmp_1;
          destination.s3(tmp, tmp$ret$3);
        }
        return plus_2(on, destination);
      }
      r3q(on) {
        return this.t43((!(on == null) ? isInterface(on, KtMap()) : false) ? on : THROW_CCE());
      }
      toString() {
        return 'ModifyByKey(map=' + toString(this.u43_1) + ')';
      }
      hashCode() {
        return hashCode(this.u43_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ModifyByKey()))
          return false;
        if (!equals(this.u43_1, other.u43_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ModifyByKey', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_21});
    ModifyByKeyClass = $;
  }
  return ModifyByKeyClass;
}
var RemoveKeysClass;
function RemoveKeys() {
  if (RemoveKeysClass === VOID) {
    class $ extends Modification() {
      static x43(fields) {
        var $this = this.e42();
        $this.w43_1 = fields;
        return $this;
      }
      t43(on) {
        // Inline function 'kotlin.collections.filterKeys' call
        var result = LinkedHashMap().f6();
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = on.d2().m1();
        while (_iterator__ex2g4s.n1()) {
          var entry = _iterator__ex2g4s.o1();
          var it = entry.e2();
          if (!this.w43_1.t1(it)) {
            result.s3(entry.e2(), entry.f2());
          }
        }
        return result;
      }
      r3q(on) {
        return this.t43((!(on == null) ? isInterface(on, KtMap()) : false) ? on : THROW_CCE());
      }
      toString() {
        return ' -= ' + toString(this.w43_1);
      }
      hashCode() {
        return hashCode(this.w43_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RemoveKeys()))
          return false;
        if (!equals(this.w43_1, other.w43_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'RemoveKeys', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_22});
    RemoveKeysClass = $;
  }
  return RemoveKeysClass;
}
var OnFieldClass;
function OnField() {
  if (OnFieldClass === VOID) {
    class $ extends Modification() {
      static a44(key, modification) {
        var $this = this.e42();
        $this.y43_1 = key;
        $this.z43_1 = modification;
        return $this;
      }
      g3t(on) {
        return this.y43_1.n2j(on, this.z43_1.r3q(this.y43_1.k2j(on)));
      }
      r3q(on) {
        return this.g3t((on == null ? true : !(on == null)) ? on : THROW_CCE());
      }
      toString() {
        var tmp;
        var tmp_0 = this.z43_1;
        if (tmp_0 instanceof OnField()) {
          tmp = this.y43_1.i20() + '.' + toString(this.z43_1);
        } else {
          var tmp_1 = this.z43_1;
          if (tmp_1 instanceof Chain()) {
            tmp = this.y43_1.i20() + '.let { ' + toString(this.z43_1) + ' }';
          } else {
            tmp = this.y43_1.i20() + toString(this.z43_1);
          }
        }
        return tmp;
      }
      hashCode() {
        var result = hashCode(this.y43_1);
        result = imul(result, 31) + hashCode(this.z43_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OnField()))
          return false;
        if (!equals(this.y43_1, other.y43_1))
          return false;
        if (!equals(this.z43_1, other.z43_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'OnField');
    OnFieldClass = $;
  }
  return OnFieldClass;
}
var CompanionClass_23;
function Companion_23() {
  if (CompanionClass_23 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ModificationSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_23 = $;
  }
  return CompanionClass_23;
}
var Companion_instance_23;
function Companion_getInstance_23() {
  return Companion_instance_23;
}
var ModificationClass;
function Modification() {
  if (ModificationClass === VOID) {
    class $ {
      static e42() {
        return createThis(this);
      }
      f42() {
        return false;
      }
    }
    initMetadataForClass($, 'Modification', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_23});
    ModificationClass = $;
  }
  return ModificationClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
Companion_instance_2 = new (Companion_2())();
Companion_instance_3 = new (Companion_3())();
Companion_instance_4 = new (Companion_4())();
Companion_instance_5 = new (Companion_5())();
Companion_instance_6 = new (Companion_6())();
Companion_instance_7 = new (Companion_7())();
Companion_instance_8 = new (Companion_8())();
Companion_instance_9 = new (Companion_9())();
Companion_instance_10 = new (Companion_10())();
Companion_instance_11 = new (Companion_11())();
Companion_instance_12 = new (Companion_12())();
Companion_instance_14 = new (Companion_14())();
Companion_instance_15 = new (Companion_15())();
Companion_instance_16 = new (Companion_16())();
Companion_instance_17 = new (Companion_17())();
Companion_instance_18 = new (Companion_18())();
Companion_instance_20 = new (Companion_20())();
Companion_instance_21 = new (Companion_21())();
Companion_instance_22 = new (Companion_22())();
Companion_instance_23 = new (Companion_23())();
//endregion
//region block: exports
export {
  AppendRawString as AppendRawString2twa0g1pq2wsh,
  AppendString as AppendString3a1k249xx52p6,
  Assign as Assign2nr5v5j409ffp,
  Chain as Chainlkbkk6tcx8wg,
  CoerceAtLeast as CoerceAtLeast1qec5fy91tzrc,
  CoerceAtMost as CoerceAtMost3d63rbc83rbza,
  Combine as Combine39jly1szyd8uz,
  IfNotNull as IfNotNull2i0zh8hr8em4r,
  Increment as Increment34m77r2mp8qrl,
  ListAppend as ListAppend2l1q2g9n9gupy,
  ListDropFirst as ListDropFirst3anrtu81y5hmf,
  ListDropLast as ListDropLast3dtmf7u6qkj2m,
  ListPerElement as ListPerElement1svj6v7vx2rkd,
  ListRemoveInstances as ListRemoveInstances18gi59vc9xu0e,
  ListRemove as ListRemove2avniudn03c1m,
  ModifyByKey as ModifyByKey26rgyr9ctzu42,
  Multiply as Multiply2vbqtqfo8ocrx,
  Nothing as Nothing18o11lo0yw6xd,
  OnField as OnFieldsnrykjjrmtcs,
  RemoveKeys as RemoveKeys34p6j7mjgfhm6,
  SetAppend as SetAppend2k79v2d727eg7,
  SetDropFirst as SetDropFirst3sc6ml7wbavtv,
  SetDropLast as SetDropLast16suuclx5epig,
  SetPerElement as SetPerElement1iju3wf4wq6tr,
  SetRemoveInstances as SetRemoveInstances32hzcc0ox5b27,
  SetRemove as SetRemove2xr7mvrx67bk4,
  Modification as Modification187ho6cz13sbh,
  Companion_instance_7 as Companion_instance1stph8yw2qjt5,
  Companion_instance_6 as Companion_instance3i2oc9fl7dqwb,
  Companion_instance_1 as Companion_instance2xh5qtziumx9l,
  Companion_instance as Companion_instanceh1zhnl1id9u6,
  Companion_instance_3 as Companion_instance2bxh5k04i38vl,
  Companion_instance_2 as Companion_instance3b2ql10d66of8,
  Companion_instance_20 as Companion_instance35mjssmfxcqi1,
  Companion_instance_23 as Companion_instance30d6g5ap8rdfm,
  Companion_instance_0 as Companion_instance3iz3lmuiwm4gs,
  Companion_instance_4 as Companion_instance1803vszd3jkgu,
  Companion_instance_8 as Companion_instanceqw27e6orr13x,
  Companion_instance_11 as Companion_instanceplmfjmw1b8eo,
  Companion_instance_12 as Companion_instance1u3htj9m9i4vw,
  Companion_getInstance_13 as Companion_getInstance15on8pfywvj4u,
  Companion_instance_9 as Companion_instance3tbsu8lc454o8,
  Companion_instance_10 as Companion_instance3l6pokebxu46n,
  Companion_instance_21 as Companion_instance1cmtpto9j9iy1,
  Companion_instance_5 as Companion_instance3jdqbmrdwjecn,
  Nothing_getInstance as Nothing_getInstance2cox2iic6p9qw,
  Companion_instance_22 as Companion_instance1mmg08h7zlnuq,
  Companion_instance_14 as Companion_instanceogftm8o6mnqa,
  Companion_instance_17 as Companion_instance1thnnb3838mfv,
  Companion_instance_18 as Companion_instance2992tql2kbmd,
  Companion_getInstance_19 as Companion_getInstance3kmlqavk0jt8f,
  Companion_instance_15 as Companion_instance1za9qc8wkqj85,
  Companion_instance_16 as Companion_instancexixyq1cxutlm,
};
//endregion

//# sourceMappingURL=Modification.mjs.map
